import { render, staticRenderFns } from "./ActivityThumbnails.vue?vue&type=template&id=2f207ccc&scoped=true&"
import script from "./ActivityThumbnails.vue?vue&type=script&lang=ts&"
export * from "./ActivityThumbnails.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityThumbnails.vue?vue&type=style&index=0&id=2f207ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f207ccc",
  null
  
)

/* custom blocks */
import block0 from "./ActivityThumbnails.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports